(function($) {
    $(document).ready(function() {
        const body = $('body')
        body.on('click', function() {
            body.find('.dropdown-form').removeClass('open')
        })

        body.on('click', '.dropdown-form', function(e) {
            /**
             * @type {MouseEvent} e
             */
            e.stopPropagation()
        })

        body.on('click', '.dropdown-form .toggle-button', function () {
            this.scrollIntoView()
            const dropdownForm = $(this).parent('.dropdown-form')
            if (dropdownForm.hasClass('open')) {
                $('body .dropdown-form').removeClass('open')
            } else {
                $('body .dropdown-form').removeClass('open')
                dropdownForm.addClass('open')
            }
        })
    })
})(window.jQuery);
